import React, { useCallback } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { PainSection } from '../components/PainSection';
import { TransformationSection } from '../components/TransformationSection';
import { WhatIsSection } from '../components/WhatIsSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { IncludesSection } from '../components/IncludesSection';
import { PriceSection } from '../components/PriceSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
export function Landing() {
  const scrollToPrice = useCallback(() => {
    document.getElementById('precio')?.scrollIntoView({
      behavior: 'smooth'
    });
  }, []);
  return <div className="w-full bg-crema font-sans text-tinta" data-id="element-179" data-mp="m724c3x1gp3d">
      <Header onCTA={scrollToPrice} data-id="element-180" data-mp="m5h90c2wh24g" />
      <main data-id="element-181" data-mp="2ajvb4mpwccb">
        <Hero onCTA={scrollToPrice} data-id="element-182" data-mp="2b3a4ch2mkm4" />
        <PainSection data-id="element-183" data-mp="27xkmw4j5gpv" />
        <TransformationSection data-id="element-184" data-mp="3tgbgrqpjv0ss" />
        <WhatIsSection data-id="element-185" data-mp="3tfa45hsvy68y" />
        <HowItWorksSection data-id="element-186" data-mp="3tes1a2bpwts2" />
        <IncludesSection data-id="element-187" data-mp="3tio6wr5gohgx" />
        <PriceSection onCTA={scrollToPrice} data-id="element-188" data-mp="3pe844yr59q5x" />
        <GuaranteeSection data-id="element-189" data-mp="3pezzq9kqrnw7" />
        <FAQSection data-id="element-190" data-mp="3kfn16rkicsds" />
        <FinalCTASection onCTA={scrollToPrice} data-id="element-191" data-mp="3kg6jwahzfksv" />
      </main>
      <Footer data-id="element-192" data-mp="3khq3a9yxqbyv" />
    </div>;
}